import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { instance } from "api/apiBase";

export const SUPPORT_AGENT_TOOLTIP =
  "Application support agent reviews and resolves applicant escalation " +
  "signals to drive submitted applications. All agent actions are reviewed " +
  "and approved by a human.";

// `onChanged` fires on the optimistic flip (before the PATCH) and again with
// the previous value if it fails, so a host deriving `active` from a cached
// query can mirror the flip.
export const useSupportAgentState = ({
  applicantId,
  active,
  onChanged
}: {
  applicantId: number;
  active: boolean;
  onChanged?: (active: boolean) => void;
}) => {
  const [agentActive, setAgentActive] = useState(active);

  useEffect(() => {
    setAgentActive(active);
  }, [active]);

  const handleToggle = async (value: boolean) => {
    setAgentActive(value);
    onChanged?.(value);
    try {
      await instance.patch(
        `/portal/v1/agents/applicants/${applicantId}/application_support_agent`,
        { active: value }
      );
    } catch {
      setAgentActive(!value);
      onChanged?.(!value);
      toast.error("Failed to update the application support agent");
    }
  };

  return { agentActive, handleToggle };
};
